const Helper = require("./helper");
const config = require('../../config');
import GetStreamAPI from '../common/get-stream-api';

// Encoded values of different schedule types
const ContentAccessNotificationScheduleMapping = {
    'BEFORE-START-DATE': 'MA',
    'START-DATE': 'MQ',
    'BEFORE-END-DATE': 'Mg'
};

export default function jsonTransform(json) {
    const flattenedJson = jsonBasedOnVerb(json);
    const renderableJSON = mapFlattenJsonToRenderableJson(flattenedJson)
    return renderableJSON;
}

function jsonBasedOnVerb(json) {
    const notificationHtmlJson = {
        ...json,
        count: json.results.length,
        results: []
    }
    const currentCursorOffset = json.cursorOffset;
    json.results.map((groupFeed, index) => {
        const activity = groupFeed.activities[0];
        let bundleProduct;
        if(activity?.verb ==='evaluated' && activity?.bundle?.data?.products?.length > 0 && activity.product?.data && activity.product?.data['product-code']) {
            bundleProduct = activity.bundle.data.products.find((bP) => bP['dls-product']['code'] === activity.product.data['product-code']);
        }
        /* activity count greater than one, means aggregated notifications - teacher-invited notifications */
        /* if(groupFeed.activity_count > 1) { 
            // group feed activities can be aggregated for some data, if needed
        } */
        if(GetStreamAPI.getLaunchType() === 'lti' && activity.verb === 'invited') {
            notificationHtmlJson.unread--;
            return;
        }
        notificationHtmlJson.results.push({
            icon: getIconBasedOnVerb(activity.verb, activity),
            imageSrc: getImageSrcFromActivityData(activity),
            svg: getSVGBasedOnVerb(activity),
            title: getTitleBasedOnVerb(activity.verb, groupFeed.activity_count, activity),
            reference: getReferenceFromActivityData(activity, groupFeed.activity_count),
            details: getDetailsBasedOnVerb(activity.verb, groupFeed.activity_count, activity.role, activity),
            redirectLink: getRedirectFromActivityData(activity),
            time: activity.time,
            is_read: groupFeed.is_read,
            is_seen: groupFeed.is_seen,
            groupActivityId: groupFeed.id, // Group id needed for mark_read the activity
            qidIndex: currentCursorOffset + index,
            ...(activity.verb ==='new_content_umbrella') && { verbInfo: {
                verb: "new_content_umbrella",
                metadata: {
                    bundleCode: activity?.object?.data && activity.object.data['bundle-code'],
                    productCode: activity?.product?.data && activity.product.data['product-code']
                }
              } 
            },
            ...(activity.verb ==='evaluated') && { verbInfo: {
                verb: "evaluated",
                metadata: {
                    spaceId: activity?.space_id,
                    classId: activity?.class_id,
                    itemCode: activity?.object?.data['item-code'],
                    productCode: activity?.product?.data && activity.product.data['product-code'],
                    lp_version: bundleProduct && bundleProduct['learning-path'] && bundleProduct['learning-path'].version 
                }
              } 
            },
            ...(activity.verb ==='class_announcement') && { verbInfo: {
                verb: 'class_announcement',
                attachments: activity.attachments, // Add attachments to the object
                foreign_id: activity.foreign_id, // Add foreign_id to the object
                spaceId: activity?.org_id,
                classId: activity?.object?.id
              }
            }
        });
    })
    notificationHtmlJson.results = notificationHtmlJson.results.sort((a, b) => new Date(b.time) - new Date(a.time));
    return notificationHtmlJson;
}

function mapFlattenJsonToRenderableJson(notificationJson) {
    const mappedJson = {
        ...notificationJson,
        results: [
            {
                'title': 'Today',
                'entities': []
            },
            {
                'title': 'Last Seven days',
                'entities': []
            },
            {
                'title': 'Older',
                'entities': []
            }
        ]
    }
    for (let ob of notificationJson.results) {
        let currentTime = new Date();
        let notificationDate = new Date(Helper.convertUTCTimeToUTCEpoch(ob.time, currentTime));

        ob['elapsedTime'] = Helper.calculateElapsedTime(ob.time, currentTime);
        notificationDate.setHours(0, 0, 0, 0)
        let todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        let lastSevenDaysAgoDate = new Date(todayDate.getTime() - (7 * 24 * 60 * 60 * 1000))

        // if date is of today
        if (notificationDate.getTime() >= todayDate.getTime())
            mappedJson.results[0].entities.push(ob);
        else if (notificationDate.getTime() >= lastSevenDaysAgoDate.getTime())
            mappedJson.results[1].entities.push(ob);
        else
            mappedJson.results[2].entities.push(ob);
    }
    return mappedJson;
}

function getIconBasedOnVerb(verb , activity) {

    switch(verb){
        case 'evaluated' :
        case 'evaluated_custom':
        case 'evaluated_external':
        case 'assignment_updated':
        case 'assigned': return 'product';
        case 'new_content_umbrella':
        case 'remove_user_from_school':
        case 'invited': return 'class';
        case 'class_announcement': return 'message';
        case 'school_report_processed':
        case 'class_report_processed': return 'report';
        case 'content_unlocked': {
            return (activity.rule_info?.schedule_type === 'BEFORE-END-DATE') ? 'lock' : 'unlock';
        }
        case 'content_locked': {
            return (activity.rule_info?.schedule_type === 'BEFORE-END-DATE') ? 'unlock' : 'lock';
        }
        default: return 'class';
    }
}

function getSVGBasedOnVerb(activity) {
    const unlockIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 1;">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 7C7 4.23858 9.23858 2 12 2C14.4189 2 16.4366 3.71767 16.8999 5.99982L14.8293 6.00009C14.4175 4.83485 13.3063 4 12 4C10.4023 4 9.09634 5.24892 9.00509 6.82373L9 7V9H17C18.1046 9 19 9.76751 19 10.7143V19.2857C19 20.2325 18.1046 21 17 21H7C5.89543 21 5 20.2325 5 19.2857V10.7143C5 9.76751 5.89543 9 7 9V7ZM17 11H7V19H17V11ZM12 12C13.1046 12 14 12.8954 14 14C14 14.7398 13.5983 15.3858 13.0011 15.7318L13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17L10.9999 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12Z" fill="#FFFFFF"/>
    </svg>`;
    const lockIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 1;">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C14.6888 3 16.8818 5.12231 16.9954 7.78311L17 8V9C18.1046 9 19 9.76751 19 10.7143V19.2857C19 20.2325 18.1046 21 17 21H7C5.89543 21 5 20.2325 5 19.2857V10.7143C5 9.76751 5.89543 9 7 9V8C7 5.23858 9.23858 3 12 3ZM17 11H7V19H17V11ZM12 12C13.1046 12 14 12.8954 14 14C14 14.7398 13.5983 15.3858 13.0011 15.7318L13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17L10.9999 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12ZM12 5C10.4023 5 9.09634 6.24892 9.00509 7.82373L9 8V9H15V8C15 6.34315 13.6569 5 12 5Z" fill="#FFFFFF"/>
    </svg>`;
    if (activity.verb === 'school_report_processed' || activity.verb === 'class_report_processed' ){
         return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 1;">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M19 21H6V3H19V21ZM5 23H20C20.552 23 21 22.552 21 22V2C21 1.448 20.552 1 20 1H5C4.448 1 4 1.448 4 2V3H3C2.448 3 2 3.448 2 4C2 4.552 2.448 5 3 5H4V7H3C2.448 7 2 7.448 2 8C2 8.552 2.448 9 3 9H4V11H3C2.448 11 2 11.448 2 12C2 12.552 2.448 13 3 13H4V15H3C2.448 15 2 15.448 2 16C2 16.552 2.448 17 3 17H4V19H3C2.448 19 2 19.448 2 20C2 20.552 2.448 21 3 21H4V22C4 22.552 4.448 23 5 23Z"
          fill="#FFFFFF" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.4972 12.0039H7.49316C7.21716 12.0039 6.99316 11.7799 6.99316 11.5039C6.99316 10.3179 7.47416 9.15788 8.31316 8.31888C9.15116 7.48088 10.3122 6.99988 11.4972 6.99988C11.7742 6.99988 11.9972 7.22388 11.9972 7.49988V11.5039C11.9972 11.7799 11.7742 12.0039 11.4972 12.0039ZM8.03016 11.0039H10.9972V8.03688C10.2552 8.14588 9.55316 8.49288 9.02016 9.02588C8.48616 9.55988 8.13916 10.2619 8.03016 11.0039ZM13.4962 17.0001C11.7342 17.0001 10.2712 15.6921 10.0282 13.9961H13.4962C13.7732 13.9961 13.9962 13.7721 13.9962 13.4961V10.0281C15.6932 10.2711 17.0002 11.7341 17.0002 13.4961C17.0002 15.4281 15.4282 17.0001 13.4962 17.0001ZM8.99216 13.4961C8.99216 15.9791 11.0132 18.0001 13.4962 18.0001C15.9802 18.0001 18.0002 15.9791 18.0002 13.4961C18.0002 11.0131 15.9802 8.99208 13.4962 8.99208C13.2202 8.99208 12.9962 9.21608 12.9962 9.49208V12.9961H9.49216C9.21616 12.9961 8.99216 13.2201 8.99216 13.4961Z"
          fill="#FFFFFF" />
      </svg>`;
    } else if (activity.verb === 'content_unlocked') {
        return (activity.rule_info?.schedule_type === 'BEFORE-END-DATE') ? lockIcon : unlockIcon;
    } else if (activity.verb === 'content_locked') {
        return (activity.rule_info?.schedule_type === 'BEFORE-END-DATE') ? unlockIcon : lockIcon;
    } else if (activity.verb === 'evaluated_custom') {
        return `<svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 1;" >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.143 17.4256L15.7144 17.4282V5.42815H7.143V17.4256ZM16.5716 19.1424L6.28585 19.1399C5.81271 19.1399 5.42871 18.7559 5.42871 18.2827V4.57101C5.42871 4.09787 5.81271 3.71387 6.28585 3.71387H16.5716C17.0447 3.71387 17.4287 4.09787 17.4287 4.57101V18.2853C17.4287 18.5133 17.3387 18.731 17.1776 18.8913C17.0173 19.0524 16.7987 19.1424 16.5716 19.1424ZM19.143 21.7142L8.85728 21.7108C8.38328 21.7108 8.00014 21.3268 8.00014 20.8536C8.00014 20.3805 8.38414 19.9965 8.85728 19.9965L18.2859 19.9999V7.14278C18.2859 6.66964 18.6699 6.28564 19.143 6.28564C19.6161 6.28564 20.0001 6.66964 20.0001 7.14278V20.8571C20.0001 21.0842 19.9101 21.3028 19.749 21.4631C19.5887 21.6242 19.3701 21.7142 19.143 21.7142ZM10.5716 23.4251C10.5716 23.8982 10.9547 24.2822 11.4287 24.2822L21.7144 24.2856C21.9416 24.2856 22.1601 24.1956 22.3204 24.0345C22.4816 23.8742 22.5716 23.6556 22.5716 23.4285V9.71421C22.5716 9.24107 22.1876 8.85707 21.7144 8.85707C21.2413 8.85707 20.8573 9.24107 20.8573 9.71421V22.5714L11.4287 22.5679C10.9556 22.5679 10.5716 22.9519 10.5716 23.4251Z" fill="#FFFFFF"/>
        </svg>`;
    }
    return '';
}

function getImageSrcFromActivityData(activity) {
    switch (activity.verb){
        case 'evaluated':
        case 'evaluated_external':
        case 'assignment_updated':
        case 'assigned': { 
            if (activity.bundle?.data?.path && activity.bundle?.data?.image && activity.product?.data?.['product-code']) {
                return activity.bundle.data.path + '/' + activity.product.data['product-code'] + '/' + activity.bundle.data.image;
            } else {
                return '';
            }
        }
        case 'new_content_umbrella': {
            if (activity.object?.data?.path && activity.object?.data?.image && activity.product?.data?.['product-code']) {
                return activity.object.data.path + '/' + activity.product.data['product-code'] + '/' + activity.object.data.image;
            } else {
                return '';
            }
        }
        case 'content_locked': case 'content_unlocked': { 
            if (activity.bundle?.data?.path && activity.bundle?.data?.image && activity.product_id) {
                return activity.bundle.data.path + '/' + activity.product_id + '/' + activity.bundle.data.image;
            } else {
                return '';
            }
        }
        case 'remove_user_from_school': {
            return '';
        }
        default: return '';
    }
}

function getTitleBasedOnVerb(verb, activity_count, activity) {
    switch(verb){
        case 'evaluated_custom':
        case 'evaluated': return 'New feedback';
        case 'assigned': return 'Assignment set';
        case 'assignment_updated': {
            if (activity['updated_params'].includes('duedate')) return 'New due date';
            break;
        }
        case 'invited': {
            if(activity_count > 1) return 'New class invitations:';
            else return 'New class invitation';
        }
        case 'evaluated_external': {
            let bundleCode = activity.bundle?.data?.['bundle-code'] ? activity.bundle.data['bundle-code'] : undefined ;
            if(activity["score_part"] == "2" && bundleCode == config.ieltsBundleCode) return 'New feedback';
            return 'Test scores received';
        }
        case 'new_content_umbrella': return 'New content available';
        case 'remove_user_from_school': {
            return 'School affiliation removed';
        }
        case 'class_announcement': return activity.announcement_title;
        case 'school_report_processed':
        case 'class_report_processed': {
            let reportType;
            if (activity.report_type === 'CLASS_SUMMARY') reportType = 'Class summary';
            else if (activity.report_type === 'CLASS_DETAILED_DATA') reportType = 'Class detailed data';
            else if (activity.report_type === 'CLASS_DAILY_DATA') reportType = 'Class daily data';
            else if (activity.report_type === 'ASSIGNMENT_SUMMARY') {
                if(activity.is_lti_report === true) {
                    reportType = 'Custom links summary';
                } else {
                    reportType = 'Assignments summary';
                }
            }
            else if (activity.report_type === 'AGGREGATED_DATA') reportType = 'Aggregated data';
            else if (activity.report_type === 'ASSIGNMENT_DETAILED_DATA') {
                if(activity.is_lti_report === true) {
                    reportType = 'Custom links detailed data';
                } else {
                    reportType = 'Assignments detailed data';
                }
            }
            else if (activity.report_type === 'ESTIMATED_CEFR_LEVEL') reportType = ' Estimated CEFR level';
            if (activity.status === 'error') return `${reportType} report generation failure`;
            else if (activity.status === 'partial_error') return `Your ${reportType} report is ready to download`;
            return `Your ${reportType} report is ready`;
        }
        case 'content_unlocked': {
            const componentTitle = activity.object?.data?.title;
            const date = Helper.createDateTimeStr(activity.rule_info?.schedule_type === 'BEFORE-START-DATE' ? activity.rule_info?.start_date : activity.rule_info?.end_date);
            switch (activity.rule_info?.schedule_type) {
                case 'BEFORE-START-DATE': return `Some content from ${componentTitle} will be available to you from tomorrow ${date}`;
                case 'START-DATE': return `Some content in ${componentTitle} is now available to you`;
                case 'BEFORE-END-DATE': return `Your access to some content in ${componentTitle} will end tomorrow ${date}`;
                default: return '';
            }
        }
        case 'content_locked': {
            const componentTitle = activity.object?.data?.title;
            const date = Helper.createDateTimeStr(activity.rule_info?.schedule_type === 'BEFORE-START-DATE' ? activity.rule_info?.start_date : activity.rule_info?.end_date);
            switch (activity.rule_info?.schedule_type) {
                case 'BEFORE-START-DATE': return `Your access to some content in ${componentTitle} will end tomorrow ${date}`;
                case 'START-DATE': return `Your access to some content in ${componentTitle} has now ended`;
                case 'BEFORE-END-DATE': return `Some content from ${componentTitle} will be available to you from tomorrow ${date}`;
                default: return '';
            }
        }
        default: return '';
    }
}
function getReferenceFromActivityData(activity, activity_count) {
    switch (activity.verb){
        case 'evaluated':
        case 'assignment_updated':
        case 'assigned': {
            return activity.object?.data?.title ? activity.object.data.title : '';
        }
        case 'invited': {
            if(activity_count > 1) return activity_count;
            else return activity.class?.data?.title ? activity.class.data.title : '';
        }
        case 'evaluated_external': {

            let bundleCode = activity.bundle?.data?.['bundle-code'] ? activity.bundle.data['bundle-code'] : undefined;
            
            if(activity["score_part"] == "2" && bundleCode == config.ieltsBundleCode)
            {
                let testName = activity.object?.data?.title ? activity.object.data.title : '';

                return testName;
            }
            return activity.object?.data?.title ? activity.object.data.title : '';
        }
        case 'new_content_umbrella' : {
            if (activity.product?.data?.title && activity.object?.data?.title){
                return `${activity.product.data.title}, ${activity.object.data.title}`
            }

           return '';
        }
        case 'remove_user_from_school': {
            return activity.school_name;
        }
        case 'class_announcement': return activity.object?.data?.title;
        case 'school_report_processed': {
            if (activity.status === 'partial_error') return `Some classes were not included`;
            return '';
        }
        case 'evaluated_custom': {
            return activity?.custom_component?.title ? activity.custom_component.title : '';
        }
        default: return '';
    }
}
function getDetailsBasedOnVerb(verb, activity_count, role, activity) {
    switch (verb) {
        case 'evaluated_custom':
        case 'evaluated': return 'Your teacher has sent you some feedback';
        case 'assigned': return 'Your teacher has set a new assignment';
        case 'assignment_updated': {
            if (activity['updated_params'].includes('duedate')) return 'Your teacher has set a new due date for this assignment';
            break;
        }
        case 'invited': {
            if(role === 'student') return 'You are invited to learn in a class. Do you want to accept?';
            else {
                if(activity_count > 1) return 'You are invited to teach in some classes. Do you want to accept?';
                else return 'You are invited to teach in a class. Do you want to accept?';
            }
        }
        case 'evaluated_external': {

            let bundleCode = activity.bundle?.data?.['bundle-code'] ? activity.bundle.data['bundle-code'] : undefined ;
            
            if(activity["score_part"] == "2" && bundleCode == config.ieltsBundleCode)
            {
                
                let testName = activity.object?.data?.title ? activity.object.data.title : '';
                return 'Feedback for your ' + testName + ' is now available';
            }
            return 'Your test has been marked';
        }
        case 'new_content_umbrella' : {
            if (activity.product?.data?.title && activity.object?.data?.title){
                return `View new content for your ${activity.product.data.title} in ${activity.object.data.title}`
            }
            return '';
        }
        case 'remove_user_from_school': {
            return 'You no longer have access to this school account or any of its associated classes. We’ve sent you an email with more information';
        }
        case 'class_announcement': return activity.announcement_description;
        case 'school_report_processed':
        case 'class_report_processed': {
            let reportType;
            if (activity.report_type === 'CLASS_SUMMARY') reportType = 'Class summary';
            else if (activity.report_type === 'CLASS_DETAILED_DATA') reportType = 'Class detailed data';
            else if (activity.report_type === 'CLASS_DAILY_DATA') reportType = 'Class daily data';
            else if (activity.report_type === 'ASSIGNMENT_SUMMARY') {
                if(activity.is_lti_report === true) {
                    reportType = 'Custom links summary';
                } else {
                    reportType = 'Assignments summary';
                }
            }
            else if (activity.report_type === 'ASSIGNMENT_DETAILED_DATA') {
                if(activity.is_lti_report === true) {
                    reportType = 'Custom links detailed data';
                } else {
                    reportType = 'Assignments detailed data';
                }
            }
            else if (activity.report_type === 'ESTIMATED_CEFR_LEVEL') reportType = ' Estimated CEFR level';
            if (activity.status === 'error') return `Sorry, something went wrong. The ${reportType} report you requested failed to generate. Details available ${verb === 'class_report_processed' ? 'on the Reports page' : 'in the Reports tab'}`;
            else if (activity.status === 'partial_error') return `Details available in the Reports tab`;
            return `View your report, available to download ${verb === 'class_report_processed' ? 'on the Reports page' : 'in the Reports tab'}`;
        }
        case 'content_unlocked': {
            const date = Helper.createDateTimeStr(activity.rule_info?.end_date);
            switch (date && activity.rule_info?.schedule_type) {
                case 'BEFORE-START-DATE': case 'START-DATE': return `Access will end on ${date} <br/> View details`;
            }
            return 'View details';
        }
        case 'content_locked': {
            const date = Helper.createDateTimeStr(activity.rule_info?.end_date);
            switch (date && activity.rule_info?.schedule_type) {
                case 'BEFORE-START-DATE': case 'START-DATE': return `It will be available again from ${date} <br/> View details`;
            }
            return 'View details';
        }
        default: return '';
    }
}
function getRedirectFromActivityData(activity) {
    switch (activity.verb) {
        case 'evaluated': {
            return;
        }
        case 'evaluated_custom': {
            return `${window.location.origin}/class/learner/${activity.space_id}/class/${activity.class_id}/bundle/other_grades#ccCode=${activity?.custom_component?.code}`;
        }
        case 'assignment_updated':
        case 'assigned': {
            return `${window.location.origin}/class/learner/${activity.space_id}/class/${activity.class_id}/assignments#aid=${activity.object?.id}`;
        }
        case 'invited': {
            return `${window.location.origin}/dashboard/invitation/main?back=true`;
        }
        case 'evaluated_external': {
            if(activity?.bundle?.data['bundle-code']
             && activity.product.data && activity.product.data['product-code'] 
             && activity.object.data && activity.object.data['item-code']) {
                const spaceId = activity["space_id"]; 
                const bundleCode = activity.bundle.data['bundle-code'];
                const productCode = activity.product.data['product-code'];
                const itemCode = activity.object.data['item-code'].split('/').join('%2F');

                if(activity["score_part"] == "2" && bundleCode == config.ieltsBundleCode)
                {
                    return `${window.location.origin}/ieltsi/${spaceId}/product/${productCode}/test/${itemCode}/results`;
                }

                if(activity.class_id){
                    return `${window.location.origin}/class/learner/${spaceId}/class/${activity.class_id}/bundle/${activity.bundle.data['bundle-code']}#product=${productCode}&item=${itemCode}`;
                }
                else{
                    return `${window.location.origin}/class/learner/${spaceId}/bundle/${activity.bundle.data['bundle-code']}#product=${productCode}&item=${itemCode}`;
                }
            }
            return '';
        }

        case 'remove_user_from_school': {
            return `${window.location.origin}/dashboard/teacher/dashboard`;
        }
        case 'class_report_processed': return `${window.location.origin}/class/teacher/${activity.space_id}/class/${activity.class_id}/reports`;
        case 'school_report_processed': return `${window.location.origin}/admin/admin/${activity.space_id}/reports`;
        case 'content_locked': case 'content_unlocked': {
            const scheduleType = ContentAccessNotificationScheduleMapping[activity.rule_info?.schedule_type];
            return `${window.location.origin}/dashboard/learner/${activity.space_id}/class/${activity.class_id}/product/${activity.product_id}/content-access/${activity.rule_info?.rule_id}/${scheduleType}`;
        }
        default: return '';
    }
}